






import {Component, Vue, Prop} from 'vue-property-decorator';

@Component({})
export default class FlagIcon extends Vue {
  @Prop() public color!: string;

  public getFlagSrc() {
    return require(`../../assets/icons/flags/${this.color.toLowerCase()}.png`);
  }

}
